import React, { useState, useEffect} from "react";
import { Row, Col } from "reactstrap";
import { faMicrophone, faMicrophoneSlash } from "@fortawesome/free-solid-svg-icons";
import useSpeechToText from 'hooks/useSpeechToText'; 
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip'; 
import TextEditor from "components/Editor/TextEditor";
import { v4 as uuidv4 } from 'uuid';

function Speakable({ onChange, value }) {
    const [listenStarted, setListenStarted] = useState(false);
    const locale = 'de-DE'
    const { transcript, isListening, error: listenError, startListening, stopListening, setTranscript } = useSpeechToText(locale, false);
    const handleMicrophoneClick = () => {
        if (isListening) {
            stopListening();
        } else {
            setListenStarted(true)
            startListening();
        }
    };

    useEffect(() => {value && setTranscript(value)}, [])

    useEffect(() => {
        if(listenStarted && transcript){
            onChange(transcript)
        }
    }, [transcript]);

    return (<>
                <div style={{minWidth: "80%", maxWidth: "100%", overflowX: 'auto'}}>
                    <TextEditor
                        id={`editor_${uuidv4()}`}
                        initialContent={transcript}
                        value={transcript}
                        onChange={onChange}/>
                </div>
                <IconButtonWithTooltip translationId={`emails.ai.speak`} icon={isListening ? faMicrophoneSlash : faMicrophone} onClick={handleMicrophoneClick} type="Button"/>
            </>
    );
}

export default Speakable
